export default "__VITE_ASSET__d3f72040__"